//src/componentes/Modal.js
import React from 'react';
import { Modal } from 'react-bootstrap';
import './Modal.css';

const CustomModal = ({ show, handleClose, title, children }) => {
  return (
    <Modal 
      show={show} 
      onHide={handleClose} 
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="custom-modal-dialog"
    >
      <Modal.Header closeButton className="modal-header">
        <div className="modal-logo-container">
          <img 
            src="https://i.ibb.co/DP776ngT/logo.png" 
            alt="Logo Academia Pixel" 
            className="modal-logo"
          />
          <Modal.Title>{title}</Modal.Title>
        </div>
      </Modal.Header>
      <Modal.Body className="modal-body">
        {children}
      </Modal.Body>
    </Modal>
  );
};

export default CustomModal;